module.exports = __webpack_public_path__ + "static/media/Relationnel.a3447fa4.jpg";